import { render, staticRenderFns } from "./noticDialog.vue?vue&type=template&id=7355a532&scoped=true"
import script from "./noticDialog.vue?vue&type=script&lang=js"
export * from "./noticDialog.vue?vue&type=script&lang=js"
import style0 from "./noticDialog.vue?vue&type=style&index=0&id=7355a532&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7355a532",
  null
  
)

export default component.exports